import NavigationDesktop from 'ui/snippets/navigation/NavigationDesktop';

export default NavigationDesktop;
